/* Bioroot header extras on top of Dawn's header-drawer / header-menu / sticky-header. */
(() => {
  /*
   * Title-bar close button inside the mobile menu drawer (.menu-drawer__close-menu-btn).
   * Dawn's MenuDrawer binds every <button> in the drawer to "close submenu", which would leave the
   * body scroll-locked. Intercept in the capture phase and close the whole drawer instead.
   */
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.menu-drawer__close-menu-btn');
      if (!button) return;
      const drawer = button.closest('header-drawer');
      const summary = drawer && drawer.querySelector('#Details-menu-drawer-container > summary');
      if (!drawer || !summary || typeof drawer.closeMenuDrawer !== 'function') return;
      event.preventDefault();
      event.stopPropagation();
      drawer.closeMenuDrawer(event, summary);
      summary.setAttribute('aria-expanded', 'false');
    },
    true
  );

  /*
   * <last-chance-bar>: countdown to local midnight, revealed after 400px of scroll
   * (replaces the jQuery script of Shrine's snippets/lastChance.liquid).
   */
  if (!customElements.get('last-chance-bar')) {
    customElements.define(
      'last-chance-bar',
      class LastChanceBar extends HTMLElement {
        connectedCallback() {
          this.parts = {
            hours: this.querySelector('[data-lcb="hours"]'),
            minutes: this.querySelector('[data-lcb="minutes"]'),
            seconds: this.querySelector('[data-lcb="seconds"]'),
          };
          this.onScroll = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          clearInterval(this.timer);
        }

        onScroll() {
          const show = window.scrollY > 400;
          if (show === !this.hidden) return;
          this.hidden = !show;
          // keep the sticky header height variable in sync for sections that rely on it
          const header = document.querySelector('.section-header');
          if (header) document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
        }

        tick() {
          const midnight = new Date();
          midnight.setHours(24, 0, 0, 0);
          const left = Math.max(0, midnight.getTime() - Date.now());
          const pad = (n) => String(n).padStart(2, '0');
          if (this.parts.hours) this.parts.hours.textContent = pad(Math.floor(left / 3600000) % 24);
          if (this.parts.minutes) this.parts.minutes.textContent = pad(Math.floor(left / 60000) % 60);
          if (this.parts.seconds) this.parts.seconds.textContent = pad(Math.floor(left / 1000) % 60);
        }
      }
    );
  }
})();
